import React, { useState, useEffect, useCallback, useRef } from 'react';
import AsyncSelect from 'react-select/async';
import apiCall from '../../utils/api';
import { domainIconMapRaw } from '../Onboarding/domainIconMap'; // Assuming this path is correct
import {
  CreateCardContainer,
  CreateCard,
  CardHeader,
  TitleWrapper,
  EstablishmentWrapper,
  Input,
  TextArea,
  FormationTitleInput,
  InfoSection,
  InfoGrid,
  InfoItem,
  InfoLabel,
  SubInfoLabel,
  SectionTitle,
  SectionSubtitle,
  StyledInput,
  SubInput,
  StyledTextArea,
  ButtonContainer,
  CancelButton,
  ConfirmButton,
  ErrorMessage,
  SuccessMessage,
  StyledSelect,
  ExtendedTextArea,
  CheckboxGroup,
  CheckboxItem,
  CheckboxLabel,
  CheckboxInput,
  SelectedDomainsDisplay,
  DropdownContent,
  InputWithPercentage,
  PercentageSumWarning,
  selectStyles
} from './CreateCardStyles';

// --- Constants for Dropdowns/Checkboxes --- 
const formationTypeOptions = [
    "Grande école post bac",
    "BTS",
    "Formations préparatoires à l'enseignement supérieur",
    "BUT",
    "C.M.I",
    "CPGE",
    "DEUST",
    "CS",
    "CUPGE",
    "Licence (L1)"
];

const domainOptions = Object.keys(domainIconMapRaw);
// -------------------------------------------

// --- Specialty Lists ---
const generalSpecialtyLabels = [
  'Histoire-géo, géopolitique et sciences politiques', 
  'Humanités, littérature et philosophie', 
  'Langues, littératures et cultures étrangères', 
  'Mathématiques', 
  'Numérique et sciences informatiques', 
  'Physique-Chimie', 
  'Sciences de la vie et de la Terre', 
  "Sciences de l'ingénieur", 
  'Sciences économiques et sociales', 
  'Biologie-Ecologie', 
  'Éducation physique, cultures sportives', 
  'Arts du Cirque', 
  'Arts Plastiques', 
  'Cinéma-Audiovisuel', 
  'Danse', 
  'Histoire des Arts', 
  'LCA : Grec', 
  'LCA : Latin', 
  'Musique', 
  'Théâtre-Expression dramatique', 
  'Anglais Monde Contemporain'
];

// Extract labels for Techno and Pro from provided lists
const technoSpecialtyLabels = [
    'Droit et Economie',
    'Mercatique',
    'Gestion et Finance',
    'Ressources humaines et communication',
    "Systèmes d'information et de Gestion",
    'Chimie, biologie et physiopathologie humaines',
    'Sciences et techniques sanitaires et sociales',
    '2I2D',
    'Physique-Chimie et Mathématiques',
    'Territoires et technologie',
    'Biochimie-Biologie-Biotechnologie',
    'Sciences physiques et chimiques en laboratoire',
    'Analyse et méthodes en design',
    "Conception et création en design et métiers d'art",
    'Sciences et Technologies Culinaires et Services - ESAE',
    'Gestion des ressources et alimentation',
    'Economie et gestion hôtelière',
    'Pratique musicale',
    'Culture et sciences chorégraphiques',
    'Culture et sciences musicales',
    'Pratique chorégraphiques',
    'Agronomie générale',
    'Gestion des ressources naturelles',
];

const proSpecialtyLabels = [
  "Accompagnement, soins et services à la personne option a : « à domicile »",
  "Accompagnement, soins et services à la personne option b : « en structure »",
  "Agroéquipement",
  "Aménagement et finition du bâtiment",
  "Aménagements paysagers",
  "Animation - enfance et personnes âgées",
  "Artisanat et métiers d'art - option communication visuelle pluri média",
  "Artisanat et métiers d'art opt. marchandisage visuel",
  "Artisanat et métiers d'art opt. métiers de l'enseigne et de la signalétique",
  "Artisanat et métiers d'art opt. tapisserie ameubl.",
  "Assistance à la gestion des organisations et de leurs activités",
  "Aviation générale",
  "Aéronautique option avionique",
  "Aéronautique option structure",
  "Aéronautique option systèmes",
  "Bac pro maintenance des matériels option c matériels d'espaces verts",
  "Bac pro métiers de l'électricité et de ses environnements connectés",
  "Bio-industries de transformation",
  "Boucher charcutier traiteur",
  "Boulangerie-patisserie",
  "Commercialisation et services en restauration",
  "Conducteur transport routier marchandise",
  "Conduite de productions horticoles",
  "Conduite et gestion d'une entreprise du secteur canin et félin",
  "Conduite et gestion de l'entreprise agricole",
  "Conduite et gestion de l'entreprise vitivinicole",
  "Conduite et gestion des entreprises maritimes: commerce/plaisance professionnelle option yacht",
  "Conduite et gestion entreprise hippique",
  "Construction des carrosseries",
  "Cuisine",
  "Cultures marines",
  "Electromecanicien marine",
  "Esthétique, cosmétique, parfumerie",
  "Etude et Réalisation d'Agencement",
  "Etude et définition de produits industriels",
  "Façonnage de produits imprimés, routage",
  "Forêt",
  "Gestion des milieux naturels et de la faune",
  "Gestion des pollutions et protection de l'environnement",
  "Hygiène, propreté, stérilisation",
  "Logistique",
  "Maintenance des matériels option a: agricoles",
  "Maintenance des matériels option construction et manutention",
  "Maintenance des systèmes de production connectés",
  "Maintenance des équipements industriels",
  "Maintenance et efficacité énergétique",
  "Maintenance nautique",
  "Maintenance véhicules option a voitures particulières",
  "Maintenance véhicules option b véhicules de transport routier",
  "Maintenance véhicules option c motocycles",
  "Menuisier aluminium-verre",
  "Microtechniques",
  "Métiers de l'accueil",
  "Métiers de l'entretien des textiles option b : pressing",
  "Métiers de la coiffure",
  "Métiers de la mode option vêtement",
  "Métiers de la sécurité",
  "Métiers du commerce et de la  vente option a : animation et gestion d'espace commercial",
  "Métiers du commerce et de la  vente option b: prospection client et valorisation d'offre commerciale",
  "Métiers du cuir option chaussures",
  "Métiers du cuir option maroquinerie",
  "Métiers du cuir: sellerie garnissage",
  "Métiers du froid et des énergies renouvelables",
  "Métiers du pressing et de la blanchisserie",
  "Métiers et arts de la pierre",
  "Optique lunetterie",
  "Organisation de transport de marchandises",
  "Ouvrage du bâtiment : metallerie",
  "Ouvrage du bâtiment : métal alu verre et matériaux de synthèse",
  "Perruquier posticheur",
  "Photographie",
  "Pilote de ligne de production",
  "Plastiques et composites",
  "Polyvalent navigant pont/machine",
  "Procédés de la chimie, de l'eau et des papiers-cartons",
  "Productions aquacoles",
  "Productique mécanique option décolletage",
  "Prothèse dentaire",
  "Réalisation de produits imprimés et plurimédia option a productions graphiques",
  "Réalisation de produits imprimés et plurimédia option b productions imprimées",
  "Réparation des carrosseries",
  "Services aux personnes et aux territoires",
  "Services de proximité et vie locale",
  "Systèmes numériques, option a: sûreté et sécurité des infrastructures, de l'habitat et du tertiaire",
  "Systèmes numériques, option b: audiovisuels, réseau, équipement domestiques",
  "Systèmes numériques, option c: réseaux informatiques et systèmes communicants",
  "Technicien conseil vente en alimentation",
  "Technicien conseil vente en alimentation option vins et spiritueux",
  "Technicien conseil vente en animalerie",
  "Technicien conseil vente univers jardinerie",
  "Technicien constructeur bois",
  "Technicien d'usinage",
  "Technicien d'étude du bâtiment. option a : etudes et economie",
  "Technicien d'étude du bâtiment. option b : assistant en architecture",
  "Technicien de fabrication bois et matériaux associés",
  "Technicien de maintenance de systèmes énergétiques et climatiques",
  "Technicien de scierie",
  "Technicien du bâtiment : organisation et réalisation du gros oeuvre",
  "Technicien du froid et du conditionnement de l'air",
  "Technicien en appareillage orthopédique",
  "Technicien en chaudronnerie industrielle",
  "Technicien en experimentation animale",
  "Technicien en installation des systèmes énergétiques et climatiques",
  "Technicien en prothèse dentaire",
  "Technicien en réalisation de productions mécaniques option réalisation et maintenance des outillages",
  "Technicien en réalisation de productions mécaniques. option réalisation et suivi de production",
  "Technicien gaz",
  "Technicien geomètre topographe",
  "Technicien menuisier agenceur",
  "Technicien modeleur",
  "Technicien outilleur",
  "Techniques d'interventions sur installations nucléaires",
  "Traitement des matériaux",
  "Transport",
  "Transport : transport fluvial",
  "Travaux publics",
  "installateur en chauffage, climatisation et énergies renouvelables",
  "intervention sur le patrimoine bâti option a",
  "intervention sur le patrimoine bâti option b",
  "intervention sur le patrimoine bâti option c",
  "laboratoire contrôle qualité"
];

// --- Component Logic ---

const CreateCardComponent = ({ managerUAI, onCancel, onCreateSuccess }) => {
  const [formData, setFormData] = useState({
    // --- Core Identification ---
    etablissement_id: '', // Initialize as empty, will be set by dropdown
    etablissement_nom: '', // Initialize as empty, will be set by dropdown
    formation_nom_long: '',
    // --- Location ---
    region: '',
    departement: '',
    commune: '',
    localisation: '', // Maybe combine location fields?
    // --- Type & Characteristics ---
    type_final: '', // Will be derived from selectedTypes
    duree: '', // Number of years
    apprentissage: false,
    internat: false,
    info_complementaires: '',
    amenagement: '', // What is this for? Need example
    // --- Codes ---
    code_formation: '', // Need examples/format
    code_parcoursup: '',
    code_parcoursup_portail: '',
    etablissement_id_paysage: '', // Need examples/format
    // --- Links ---
    link: '',
    site_web: '',
    stats_link: '', // Need examples/format
    // --- Outcomes ---
    poursuite_etudes: '', // Textarea, split by newline
    debouches_professionnels: '', // Textarea, split by newline
    salaire_median: '', // Number
    // --- Bac Types (%) ---
    bac_general: '', // Text? Number? Assuming number %
    bac_technologique: '', // Number %
    bac_professionnel: '', // Number %
    autres_diplomes: '', // Text description
    // --- Averages (Now conditionally shown) ---
    moyenne_formation_general: '', // Number (float)
    moyenne_formation_technologique: '', // Number (float)
    moyenne_formation_professionnel: '', // Number (float)
    // --- Costs ---
    prix_normal: '', // Number (float)
    prix_boursier: '', // Number (float)
    // --- Fields to clarify or possibly omit initially ---
    session: '', // Format? '2024'? Auto-set?
    etablissement_type: '', // From where? Auto-set?
    composante_id_paysage: '', // Format?
    rnd: '', // Format?
    type: '', // Seems redundant with formation_type/type_final
    unique_type: '', // Seems redundant
    // distribution_moyennes: {}, // JSON - Complex input needed -> OMIT FOR NOW
    // specialites_courantes: '', // Text? List? -> OMIT FOR NOW
    // score_spes_general: {}, // JSON - Handled below
    // score_spes_technologique: {}, // JSON - OMIT FOR NOW
    // score_spes_professionnel: {}, // JSON - OMIT FOR NOW
    // success: '', // Float - Relation to other stats? -> OMIT FOR NOW
  });
  const [selectedTypes, setSelectedTypes] = useState([]);
  const [selectedPrincipalDomains, setSelectedPrincipalDomains] = useState([]);
  const [selectedSecondaryDomains, setSelectedSecondaryDomains] = useState([]);
  const [percentageSumWarning, setPercentageSumWarning] = useState(null); // For Bac % sum

  // --- NEW STATE for establishments --- 
  const [establishments, setEstablishments] = useState([]);
  const [loadingEstablishments, setLoadingEstablishments] = useState(false);
  const [establishmentError, setEstablishmentError] = useState(null);
  // -------------------------------------

  // --- NEW STATE for location select --- 
  const [selectedLocation, setSelectedLocation] = useState(null);
  // -------------------------------------

  // State for specialty scores (General Bac)
  const [scoreSpesGeneral, setScoreSpesGeneral] = useState(
    // Initialize with all specialty labels as keys and empty string values
    generalSpecialtyLabels.reduce((acc, label) => {
        acc[label] = '';
        return acc;
    }, {})
  );

  // --- NEW State for Techno & Pro Scores --- 
  const [scoreSpesTechnologique, setScoreSpesTechnologique] = useState(
    technoSpecialtyLabels.reduce((acc, label) => {
        acc[label] = '';
        return acc;
    }, {})
  );
  const [scoreSpesProfessionnel, setScoreSpesProfessionnel] = useState(
    proSpecialtyLabels.reduce((acc, label) => {
        acc[label] = '';
        return acc;
    }, {})
  );
  // -----------------------------------------

  const [isPrincipalDropdownOpen, setIsPrincipalDropdownOpen] = useState(false);
  const [isSecondaryDropdownOpen, setIsSecondaryDropdownOpen] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);

  // --- NEW State for unique code generation --- 
  const [nextCodeNumber, setNextCodeNumber] = useState(0);
  // -------------------------------------------

  const titleTextareaRef = useRef(null);
  const principalDropdownRef = useRef(null);
  const secondaryDropdownRef = useRef(null);

  // --- NEW useEffect to fetch establishments --- 
  useEffect(() => {
    const fetchEstablishments = async () => {
      setLoadingEstablishments(true);
      setEstablishmentError(null);
      try {
        // First check if we have establishments in localStorage
        const managerData = localStorage.getItem('managerData');
        if (managerData) {
          const manager = JSON.parse(managerData);
          if (manager.establishments && manager.establishments.length > 0) {
            setEstablishments(manager.establishments);
            
            // If only one establishment, pre-select it
            if (manager.establishments.length === 1) {
              setFormData(prev => ({
                ...prev,
                etablissement_id: manager.establishments[0].uai,
                etablissement_nom: manager.establishments[0].name,
              }));
            }
            
            setLoadingEstablishments(false);
            return;
          }
        }
        
        // If not in localStorage, fetch from API
        const data = await apiCall(
          `${process.env.REACT_APP_BACKEND_URL}/manager/my-establishments/`,
          'GET'
        );
        
        // Update localStorage with fresh data
        if (managerData) {
          const manager = JSON.parse(managerData);
          manager.establishments = data || [];
          localStorage.setItem('managerData', JSON.stringify(manager));
        }
        
        setEstablishments(data || []);
        // If only one establishment, pre-select it
        if (data && data.length === 1) {
          setFormData(prev => ({
            ...prev,
            etablissement_id: data[0].uai,
            etablissement_nom: data[0].name,
          }));
        }
      } catch (err) {
        console.error('Error fetching establishments:', err);
        setEstablishmentError('Impossible de charger la liste des établissements.');
        setEstablishments([]);
      } finally {
        setLoadingEstablishments(false);
      }
    };

    fetchEstablishments();
  }, []);
  // -----------------------------------------------

  // --- NEW Function to load location options from API --- 
  const loadLocationOptions = async (inputValue) => {
    if (!inputValue || inputValue.length < 3) {
      return []; // Don't search if input is too short
    }
    try {
      // Use api-adresse.data.gouv.fr to search for municipalities
      const response = await fetch(`https://api-adresse.data.gouv.fr/search/?q=${encodeURIComponent(inputValue)}&type=municipality&limit=10`);
      if (!response.ok) {
        throw new Error('Failed to fetch location data');
      }
      const data = await response.json();
      
      // --- Process features to group arrondissements --- 
      const uniqueCities = {};
      data.features.forEach(feature => {
          // Basic check for municipality type (though API filter should handle this)
          if (feature.properties.type !== 'municipality') return;

          let baseCityName = feature.properties.city;
          // Try to simplify names like "Paris 15e Arrondissement" to "Paris"
          const arrondissementMatch = baseCityName.match(/^(.+?)(\s+\d+(e|er|ème)? Arrondissement)?$/i);
          if (arrondissementMatch && arrondissementMatch[1]) {
              baseCityName = arrondissementMatch[1];
          }

          // If we haven't stored this base city yet, add it
          if (!uniqueCities[baseCityName]) {
              const contextParts = feature.properties.context.split(', ');
              uniqueCities[baseCityName] = {
                  value: {
                      commune: baseCityName, // Store the simplified name
                      departement: contextParts[1]?.trim() || '', // Department
                      region: contextParts[2]?.trim() || '', // Region
                  },
                  // Display simplified label: "City, Department"
                  label: `${baseCityName}, ${contextParts[1]?.trim() || ''}`
              };
          }
      });

      // Return the processed unique city options
      return Object.values(uniqueCities);
      // -------------------------------------------------
    } catch (error) {
      console.error("Error loading location options:", error);
      return []; // Return empty array on error
    }
  };
  // -------------------------------------------------------

  // Helper to parse string to float, returning 0 if invalid/empty
  const parseFloatOrDefault = (value) => {
    if (value === null || value === undefined || String(value).trim() === '') return 0;
    const num = parseFloat(String(value).replace(',', '.'));
    return isNaN(num) ? 0 : num;
  };

  // Effect to check bac percentage sum
  useEffect(() => {
    const general = parseFloatOrDefault(formData.bac_general);
    const techno = parseFloatOrDefault(formData.bac_technologique);
    const pro = parseFloatOrDefault(formData.bac_professionnel);
    const sum = general + techno + pro;

    // Allow for small floating point inaccuracies (e.g., 99.99 or 100.01)
    if (sum > 0 && Math.abs(sum - 100) > 0.1) {
      setPercentageSumWarning(`Attention: La somme des pourcentages des types de bac (${sum.toFixed(1)}%) n'est pas égale à 100%.`);
    } else {
      setPercentageSumWarning(null); // Clear warning if sum is 0 or close to 100
    }
  }, [formData.bac_general, formData.bac_technologique, formData.bac_professionnel]);

  const adjustTextareaHeight = (element) => {
    if (element) {
      element.style.height = '1px';
      element.style.height = `${element.scrollHeight}px`;
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (principalDropdownRef.current && !principalDropdownRef.current.contains(event.target)) {
        setIsPrincipalDropdownOpen(false);
      }
      if (secondaryDropdownRef.current && !secondaryDropdownRef.current.contains(event.target)) {
        setIsSecondaryDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    
    // --- UPDATED: Handle establishment dropdown change --- 
    if (name === 'establishment_select') {
      const selectedUai = value;
      const selectedEstablishment = establishments.find(est => est.uai === selectedUai);
      setFormData(prev => ({
        ...prev,
        etablissement_id: selectedUai,
        etablissement_nom: selectedEstablishment ? selectedEstablishment.name : '',
      }));
    } else {
      // --- Original logic for other inputs --- 
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value 
      // Store boolean directly for single checkboxes like apprentissage/internat
      // For number inputs, value is already a string, parsing happens on save
    }));
    }

    if (name === 'formation_nom_long' && titleTextareaRef.current) {
      adjustTextareaHeight(titleTextareaRef.current);
    }
  };

  // --- NEW Handler for location selection change --- 
  const handleLocationChange = (selectedOption) => {
    setSelectedLocation(selectedOption); // Update the state for the select component itself
    if (selectedOption && selectedOption.value) {
      // Update formData with the structured location data
      setFormData(prev => ({
        ...prev,
        commune: selectedOption.value.commune || '',
        departement: selectedOption.value.departement || '',
        region: selectedOption.value.region || '',
      }));
    } else {
      // Clear location fields if selection is cleared
      setFormData(prev => ({
        ...prev,
        commune: '',
        departement: '',
        region: '',
      }));
    }
  };
  // -------------------------------------------------

  // --- UPDATED Generic handler for Specialty Scores --- 
  const handleScoreChange = (type, specialtyLabel, value) => {
    const setter = {
      general: setScoreSpesGeneral,
      technologique: setScoreSpesTechnologique,
      professionnel: setScoreSpesProfessionnel,
    }[type];

    if (setter) {
      setter(prev => ({
      ...prev,
      [specialtyLabel]: value // Store as string initially, parse on save
    }));
    }
  };

  const handleTypeCheckboxChange = (e) => {
      const { value, checked } = e.target;
      setSelectedTypes(prevSelectedTypes => 
          checked ? [...prevSelectedTypes, value] : prevSelectedTypes.filter(type => type !== value)
      );
  };

  const togglePrincipalDropdown = () => setIsPrincipalDropdownOpen(!isPrincipalDropdownOpen);
  const toggleSecondaryDropdown = () => setIsSecondaryDropdownOpen(!isSecondaryDropdownOpen);

  const handlePrincipalDomainChange = useCallback((e) => {
      const { value, checked } = e.target;
      setSelectedPrincipalDomains(prev =>
          checked ? [...prev, value] : prev.filter(domain => domain !== value)
      );
  }, []);

  const handleSecondaryDomainChange = useCallback((e) => {
      const { value, checked } = e.target;
      setSelectedSecondaryDomains(prev =>
          checked ? [...prev, value] : prev.filter(domain => domain !== value)
      );
  }, []);

  const formatSelectedDomains = (selectedDomains) => {
    const uniqueDomains = [...new Set(selectedDomains)];
    const count = uniqueDomains.length;
    if (count === 0) return "Sélectionner...";
    if (count <= 2) return uniqueDomains.join(', ');
    return `${count} domaines sélectionnés`;
  };

  const handleSave = async () => {
    setIsSaving(true);
    setError(null);
    setSuccess(null);

    // --- Validation Check --- 
    const requiredFields = {
      formation_nom_long: "Nom de la formation",
      etablissement_id: "Établissement", // Check the ID set by the dropdown
      commune: "Localisation (Commune)", // Check commune from location select
      departement: "Localisation (Département)", // Check departement from location select
      region: "Localisation (Région)", // Check region from location select
      duree: "Durée",
      apprentissage: "Alternance / Apprentissage", // Value is boolean/string 'true'/'false', should always be set
      internat: "Internat disponible", // Value is boolean/string 'true'/'false', should always be set
      poursuite_etudes: "Poursuite d'études",
      debouches_professionnels: "Débouchés professionnels",
      salaire_median: "Salaire médian",
      prix_normal: "Prix Normal",
      bac_general: "Profil Bac Général (%)",
      bac_technologique: "Profil Bac Technologique (%)",
      bac_professionnel: "Profil Bac Professionnel (%)",
    };

    const missingFields = [];
    for (const [field, label] of Object.entries(requiredFields)) {
      const value = formData[field];
      if (value === null || value === undefined || String(value).trim() === '') {
          // Specific check for conditionally required average fields
          if (field === 'moyenne_formation_general' && !shouldShowAverage(formData.bac_general)) continue;
          if (field === 'moyenne_formation_technologique' && !shouldShowAverage(formData.bac_technologique)) continue;
          if (field === 'moyenne_formation_professionnel' && !shouldShowAverage(formData.bac_professionnel)) continue;
        
          missingFields.push(label);
      }
    }

    // Check array/selection fields
    if (selectedTypes.length === 0) {
        missingFields.push("Type(s) de formation");
    }
    if (selectedPrincipalDomains.length === 0) {
        missingFields.push("Domaines Principaux");
    }
    // Optional: Check location selection itself
    if (!selectedLocation) {
        missingFields.push("Localisation (Commune) - Sélection"); // Specific message if selection object is missing
    }

    if (missingFields.length > 0) {
      setError(`Veuillez remplir les champs obligatoires suivants: ${missingFields.join(', ')}`);
      setIsSaving(false);
      return; // Stop submission
    }
    // --- End Validation Check ---

    // --- NEW: Generate unique code --- 
    const generatedCodeParcoursup = `HP${String(nextCodeNumber).padStart(5, '0')}`;
    // Increment for the next potential creation *immediately*
    // If the current save fails, the number is still used up for this attempt.
    setNextCodeNumber(prev => prev + 1);
    // -------------------------------

    const typeFinalString = selectedTypes.join(', ');

    // Helper to parse input string to float or null
    const parseFloatOrNull = (value) => {
        if (value === null || value === undefined || String(value).trim() === '') return null;
        const num = parseFloat(String(value).replace(',', '.')); 
        return isNaN(num) ? null : Math.round(num * 100) / 100; 
    };
    
    // Helper to parse input string to integer or null
    const parseIntOrNull = (value) => {
      if (value === null || value === undefined || String(value).trim() === '') return null;
      const num = parseInt(String(value), 10);
      return isNaN(num) ? null : num;
    };

    // Format duree back to "X ans" string if it's a number
    const formattedDuree = formData.duree && !isNaN(parseInt(formData.duree)) ? `${formData.duree} ans` : null;

    // Convert boolean strings/values to actual booleans for checkbox-like fields
    const parseBoolean = (value) => {
        if (typeof value === 'boolean') return value;
        if (typeof value === 'string') return value.toLowerCase() === 'true';
        return false; // Default to false if unsure
    };

    // Process specialty scores: parse numbers and filter out empty entries
    const finalScoreSpesGeneral = {};
    Object.entries(scoreSpesGeneral).forEach(([label, score]) => {
        const parsedScore = parseFloatOrNull(score);
        if (parsedScore !== null) {
            finalScoreSpesGeneral[label] = parsedScore;
        }
    });

    const finalScoreSpesTechnologique = {};
    Object.entries(scoreSpesTechnologique).forEach(([label, score]) => {
        const parsedScore = parseFloatOrNull(score);
        if (parsedScore !== null) {
            finalScoreSpesTechnologique[label] = parsedScore;
        }
    });

    const finalScoreSpesProfessionnel = {};
    Object.entries(scoreSpesProfessionnel).forEach(([label, score]) => {
        const parsedScore = parseFloatOrNull(score);
        if (parsedScore !== null) {
            finalScoreSpesProfessionnel[label] = parsedScore;
        }
    });

    const dataToSend = {
      // Include all fields from formData, parsing/formatting as needed
      ...formData, 
      // Overwrite/add formatted fields:
      etablissement_id: formData.etablissement_id || null, // Ensure it's sent, even if pre-filled
      type_final: typeFinalString || null,
      domaines_principaux: selectedPrincipalDomains,
      domaines_secondaires: selectedSecondaryDomains,
      duree: formattedDuree,
      apprentissage: parseBoolean(formData.apprentissage), // Ensure boolean
      internat: parseBoolean(formData.internat),         // Ensure boolean
      poursuite_etudes: formData.poursuite_etudes ? formData.poursuite_etudes.split('\n').map(s => s.trim()).filter(Boolean) : [],
      debouches_professionnels: formData.debouches_professionnels ? formData.debouches_professionnels.split('\n').map(s => s.trim()).filter(Boolean) : [],
      // Parse numeric fields
      prix_normal: parseFloatOrNull(formData.prix_normal),
      prix_boursier: parseFloatOrNull(formData.prix_boursier),
      salaire_median: parseFloatOrNull(formData.salaire_median), // Assuming median is also float/decimal
      moyenne_formation_general: parseFloatOrNull(formData.moyenne_formation_general),
      moyenne_formation_technologique: parseFloatOrNull(formData.moyenne_formation_technologique),
      moyenne_formation_professionnel: parseFloatOrNull(formData.moyenne_formation_professionnel),
      bac_general: formData.bac_general ? String(formData.bac_general) : null, // Keep as string for now, backend might expect text
      bac_technologique: formData.bac_technologique ? String(formData.bac_technologique) : null,
      bac_professionnel: formData.bac_professionnel ? String(formData.bac_professionnel) : null,
      
      // Add the processed general specialty scores
      score_spes_general: finalScoreSpesGeneral,
      score_spes_technologique: finalScoreSpesTechnologique,
      score_spes_professionnel: finalScoreSpesProfessionnel,

      // --- ADD generated code --- 
      code_parcoursup: generatedCodeParcoursup,
      // -------------------------

      // --- Omit fields explicitly ---
      mentions_specialites: undefined, // REMOVED
      formation_type: undefined, 
      distribution_moyennes: undefined,
      specialites_courantes: undefined,
      success: undefined, 
      session: undefined, 
      etablissement_type: undefined, 
      composante_id_paysage: undefined, 
      rnd: undefined, 
      type: undefined, 
      unique_type: undefined, 
      nb_proposition_admission: undefined, // REMOVED
      nb_integres: undefined, // REMOVED
    };

    // Clean up undefined properties before sending
    Object.keys(dataToSend).forEach(key => {
        if (dataToSend[key] === undefined) {
            delete dataToSend[key];
        }
        // Ensure null is sent for potentially empty numeric fields parsed by parseFloatOrNull etc.
        if (dataToSend[key] === null && ['prix_normal', 'prix_boursier', 'salaire_median', 'moyenne_formation_general', 'moyenne_formation_technologique', 'moyenne_formation_professionnel'].includes(key)) {
             // Keep null
        } else if (dataToSend[key] === '' && key !== 'formation_nom_long' && key !== 'etablissement_nom' /* allow empty text */) {
            // Convert empty strings to null for non-required text/number fields if desired, 
            // but parseFloatOrNull/parseIntOrNull already handle this for numbers.
            // Adjust logic here if backend has strict null requirements for empty strings.
        }
    });
    
    // --- VALIDATION: Ensure an establishment is selected --- 
    if (!dataToSend.etablissement_id) {
      setError('Veuillez sélectionner un établissement.');
      setIsSaving(false);
      return; // Stop submission
    }
    // --------------------------------------------------------
    
    console.log("Data being sent for creation:", dataToSend);

    try {
      const response = await apiCall(
        `${process.env.REACT_APP_BACKEND_URL}/manager/formations/create/`,
        'POST', // Use POST for creation
        dataToSend
      );
      setSuccess("Formation créée avec succès!");
      setTimeout(() => {
        setSuccess(null);
        if (onCreateSuccess) {
          onCreateSuccess(response); // Pass response data back if needed
        }
        // Optionally reset form or parts of it here
      }, 1500); // Longer timeout for success message
    } catch (err) {
      console.error('Error creating formation:', err);
      // French error messages
      let errorMsg = 'Échec de la création de la formation. Veuillez vérifier les détails et réessayer.';
      if (err.response && err.response.data) {
          if (typeof err.response.data === 'string') {
              // Use backend string error directly if it's simple
              errorMsg = err.response.data;
          } else if (typeof err.response.data === 'object') {
              // Try to extract specific field errors
              const fieldErrors = Object.entries(err.response.data)
                  .map(([field, messages]) => {
                      // Basic translation for common fields - extend as needed
                      let fieldName = field;
                      if (field === 'etablissement_id') fieldName = 'UAI Établissement';
                      if (field === 'formation_nom_long') fieldName = 'Nom de la formation';
                      if (field === 'etablissement_nom') fieldName = 'Nom Établissement';
                      if (field === 'score_spes_general') fieldName = 'Scores Spécialités (Général)';
                      // Add more translations here...
                      return `${fieldName}: ${Array.isArray(messages) ? messages.join(', ') : messages}`;
                  })
                  .join('; ');
              if (fieldErrors) {
                  errorMsg = `Erreurs de validation: ${fieldErrors}`;
              } else if (err.response.data.error) {
                  // Use specific error key if present
                  errorMsg = err.response.data.error;
              } else if (err.response.data.detail) {
                  // Use detail key if present (common in DRF)
                  errorMsg = err.response.data.detail;
              }
          }
      }
      // Prepend a general message to specific errors
      if (errorMsg !== 'Échec de la création de la formation. Veuillez vérifier les détails et réessayer.') {
          errorMsg = `Erreur: ${errorMsg}`;
      }
      setError(errorMsg);
    } finally {
      setIsSaving(false);
    }
  };

  // Helper function to check if percentage > 0
  const shouldShowAverage = (percentageValue) => {
    return parseFloatOrDefault(percentageValue) > 0;
  }

  return (
    <CreateCardContainer>
      <CreateCard>
        {/* --- Main Title --- */}
        <SectionTitle style={{ marginBottom: '1rem' }}>Informations clés</SectionTitle>

        <CardHeader>
            <TitleWrapper>
                <InfoLabel htmlFor="formation_nom_long">Nom de la formation *</InfoLabel>
                <FormationTitleInput
                ref={titleTextareaRef}
                rows="1"
                id="formation_nom_long"
                name="formation_nom_long"
                value={formData.formation_nom_long}
                onChange={handleInputChange}
                placeholder="Nom complet de la formation (obligatoire)"
                required 
                />
            </TitleWrapper>
            <EstablishmentWrapper>
                <InfoLabel htmlFor="establishment_select">Établissement *</InfoLabel>
                {loadingEstablishments ? (
                  <StyledSelect disabled><option>Chargement...</option></StyledSelect>
                ) : establishmentError ? (
                  <ErrorMessage style={{marginTop: '0.25rem'}}>{establishmentError}</ErrorMessage>
                ) : (
                  <StyledSelect
                    id="establishment_select"
                    name="establishment_select"
                value={formData.etablissement_id} 
                onChange={handleInputChange}
                required
                  >
                    <option value="">-- Sélectionner un établissement --</option>
                    {establishments.map(est => (
                      <option key={est.uai} value={est.uai}>
                        {est.name} ({est.uai})
                      </option>
                    ))}
                  </StyledSelect>
                )}
            </EstablishmentWrapper>
        </CardHeader>

        {/* --- General Info Section --- */}
        <InfoSection>
            <InfoGrid>
                 {/* --- NEW Location AsyncSelect Item --- */}
                 <InfoItem style={{ gridColumn: '1 / -1' }}> {/* Make it span full width initially */}
                   <InfoLabel htmlFor="location-search">Localisation (Commune)</InfoLabel>
                   <AsyncSelect 
                     id="location-search"
                     cacheOptions 
                     loadOptions={loadLocationOptions}
                     onChange={handleLocationChange}
                     value={selectedLocation}
                     placeholder="Rechercher une commune..."
                     noOptionsMessage={() => 'Aucune commune trouvée'}
                     loadingMessage={() => 'Chargement...'}
                     styles={selectStyles} // Apply custom styles
                   />
                   {/* Display selected values for confirmation (optional) */}
                   {/* {selectedLocation && (
                     <div style={{ fontSize: '0.8rem', color: '#555', marginTop: '0.3rem' }}>
                       Sélectionné: {formData.commune}, {formData.departement}, {formData.region}
                     </div>
                   )} */}
                    </InfoItem>
                 {/* -------------------------------------- */}
            </InfoGrid>
        </InfoSection>
        
        {/* --- Type & Characteristics Section --- */}
        <InfoSection>
          <SectionTitle>Type et caractéristiques</SectionTitle>
          <InfoGrid gridTemplateColumns="repeat(auto-fit, minmax(150px, 1fr))">
            <InfoItem style={{ gridColumn: '1 / -1' }}>
              <InfoLabel>Type(s) de formation *</InfoLabel>
              <CheckboxGroup>
                {formationTypeOptions.map(typeOption => (
                  <CheckboxItem key={typeOption}>
                    <CheckboxInput
                      id={`type-${typeOption}`}
                      value={typeOption}
                      checked={selectedTypes.includes(typeOption)}
                      onChange={handleTypeCheckboxChange}
                    />
                    <CheckboxLabel htmlFor={`type-${typeOption}`}>{typeOption}</CheckboxLabel>
                  </CheckboxItem>
                ))}
              </CheckboxGroup>
            </InfoItem>
             <InfoItem>
               <InfoLabel htmlFor="duree">Durée (années) *</InfoLabel>
               <StyledSelect id="duree" name="duree" value={formData.duree} onChange={handleInputChange} required>
                <option value="">Choisir...</option>
                {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map(year => (
                  <option key={year} value={year}>{year}</option>
                ))}
               </StyledSelect>
             </InfoItem>
             <InfoItem>
               <InfoLabel htmlFor="apprentissage">Alternance / Apprentissage *</InfoLabel>
               <StyledSelect 
                  id="apprentissage" 
                  name="apprentissage" 
                  value={String(formData.apprentissage)}
                  onChange={handleInputChange}
                >
                 <option value="false">Non</option>
                 <option value="true">Oui</option>
               </StyledSelect>
             </InfoItem>
             <InfoItem>
               <InfoLabel htmlFor="internat">Internat disponible *</InfoLabel>
               <StyledSelect 
                  id="internat" 
                  name="internat" 
                  value={String(formData.internat)}
                  onChange={handleInputChange}
                >
                 <option value="false">Non</option>
                 <option value="true">Oui</option>
               </StyledSelect>
             </InfoItem>
          </InfoGrid>
        </InfoSection>

        {/* --- Domains Section --- */}
        <InfoSection>
          <SectionTitle>Domaines enseignés</SectionTitle>
          <InfoGrid gridTemplateColumns="1fr 1fr">
            <InfoItem ref={principalDropdownRef} style={{ position: 'relative' }}>
              <InfoLabel>Domaines Principaux *</InfoLabel>
              <SelectedDomainsDisplay onClick={togglePrincipalDropdown}>
                {formatSelectedDomains(selectedPrincipalDomains)}
              </SelectedDomainsDisplay>
              {isPrincipalDropdownOpen && (
                <DropdownContent>
                  <CheckboxGroup>
                    {[...domainOptions]
                      .sort((a, b) => {
                        const aSelected = selectedPrincipalDomains.includes(a);
                        const bSelected = selectedPrincipalDomains.includes(b);
                        if (aSelected && !bSelected) return -1;
                        if (!aSelected && bSelected) return 1;
                        return a.localeCompare(b);
                      })
                      .map(domainOption => (
                      <CheckboxItem key={`principal-${domainOption}`}>
                        <CheckboxInput
                          id={`principal-${domainOption}`}
                          value={domainOption}
                          checked={selectedPrincipalDomains.includes(domainOption)}
                          onChange={handlePrincipalDomainChange}
                        />
                        <CheckboxLabel htmlFor={`principal-${domainOption}`}>{domainOption}</CheckboxLabel>
                      </CheckboxItem>
                    ))}
                  </CheckboxGroup>
                </DropdownContent>
              )}
            </InfoItem>
            <InfoItem ref={secondaryDropdownRef} style={{ position: 'relative' }}>
              <InfoLabel>Domaines Secondaires</InfoLabel>
              <SelectedDomainsDisplay onClick={toggleSecondaryDropdown}>
                {formatSelectedDomains(selectedSecondaryDomains)}
              </SelectedDomainsDisplay>
              {isSecondaryDropdownOpen && (
                <DropdownContent>
                  <CheckboxGroup>
                    {[...domainOptions]
                      .sort((a, b) => {
                        const aSelected = selectedSecondaryDomains.includes(a);
                        const bSelected = selectedSecondaryDomains.includes(b);
                        if (aSelected && !bSelected) return -1;
                        if (!aSelected && bSelected) return 1;
                        return a.localeCompare(b);
                      })
                      .map(domainOption => (
                      <CheckboxItem key={`secondary-${domainOption}`}>
                        <CheckboxInput
                          id={`secondary-${domainOption}`}
                          value={domainOption}
                          checked={selectedSecondaryDomains.includes(domainOption)}
                          onChange={handleSecondaryDomainChange}
                        />
                        <CheckboxLabel htmlFor={`secondary-${domainOption}`}>{domainOption}</CheckboxLabel>
                      </CheckboxItem>
                    ))}
                  </CheckboxGroup>
                </DropdownContent>
              )}
            </InfoItem>
          </InfoGrid>
        </InfoSection>

        {/* --- Outcomes Section --- */}
        <InfoSection>
          <SectionTitle>Débouchés et poursuites</SectionTitle>
          <InfoGrid gridTemplateColumns="1fr 1fr">
            <InfoItem>
              <InfoLabel htmlFor="poursuite_etudes">Poursuite d'études possible *</InfoLabel>
              <ExtendedTextArea id="poursuite_etudes" name="poursuite_etudes" value={formData.poursuite_etudes} onChange={handleInputChange} placeholder="Lister les poursuites d'études (une par ligne)" required/>
            </InfoItem>
            <InfoItem>
              <InfoLabel htmlFor="debouches_professionnels">Débouchés professionnels *</InfoLabel>
              <ExtendedTextArea id="debouches_professionnels" name="debouches_professionnels" value={formData.debouches_professionnels} onChange={handleInputChange} placeholder="Lister les débouchés (un par ligne)" required/>
            </InfoItem>
             <InfoItem>
              <InfoLabel htmlFor="salaire_median">Salaire médian de sortie (€) *</InfoLabel>
              <StyledInput type="number" step="any" id="salaire_median" name="salaire_median" value={formData.salaire_median} onChange={handleInputChange} placeholder="e.g., 35000" required/>
            </InfoItem>
          </InfoGrid>
        </InfoSection>

        {/* --- Costs Section --- */}
        <InfoSection>
            <SectionTitle>Coûts de la formation</SectionTitle>
            <InfoGrid>
                <InfoItem>
                <InfoLabel htmlFor="prix_normal">Prix Normal (€) *</InfoLabel>
                <StyledInput type="number" step="any" id="prix_normal" name="prix_normal" value={formData.prix_normal} onChange={handleInputChange} placeholder="e.g., 1500.00" required/>
                </InfoItem>
                <InfoItem>
                <InfoLabel htmlFor="prix_boursier">Prix Boursier (€)</InfoLabel>
                <StyledInput type="number" step="any" id="prix_boursier" name="prix_boursier" value={formData.prix_boursier} onChange={handleInputChange} placeholder="e.g., 0.00"/>
                </InfoItem>
            </InfoGrid>
        </InfoSection>

        {/* --- Admission / Bac Section --- */}
        <InfoSection>
          <SectionTitle>Profils des admis (année n-1)</SectionTitle> 
          <InfoGrid>
            <InfoItem>
              <InfoLabel htmlFor="bac_general">Profil Bac Général (%) *</InfoLabel>
              <StyledInput type="number" step="0.01" id="bac_general" name="bac_general" value={formData.bac_general} onChange={handleInputChange} placeholder="e.g., 70.5" required/>
              {shouldShowAverage(formData.bac_general) && (
                <>
                  <SubInfoLabel htmlFor="moyenne_formation_general">Moyenne Admis Bac Général *</SubInfoLabel>
                  <SubInput type="number" step="0.01" id="moyenne_formation_general" name="moyenne_formation_general" value={formData.moyenne_formation_general} onChange={handleInputChange} placeholder="e.g., 14.50" required/>
                </>
              )}
            </InfoItem>
            <InfoItem>
              <InfoLabel htmlFor="bac_technologique">Profil Bac Technologique (%) *</InfoLabel>
              <StyledInput type="number" step="0.01" id="bac_technologique" name="bac_technologique" value={formData.bac_technologique} onChange={handleInputChange} placeholder="e.g., 25.0" required/>
              {shouldShowAverage(formData.bac_technologique) && (
                <>
                   <SubInfoLabel htmlFor="moyenne_formation_technologique">Moyenne Admis Bac Techno *</SubInfoLabel>
                   <SubInput type="number" step="0.01" id="moyenne_formation_technologique" name="moyenne_formation_technologique" value={formData.moyenne_formation_technologique} onChange={handleInputChange} placeholder="e.g., 13.00" required/>
                </>
              )}
            </InfoItem>
            <InfoItem>
              <InfoLabel htmlFor="bac_professionnel">Profil Bac Professionnel (%) *</InfoLabel>
              <StyledInput type="number" step="0.01" id="bac_professionnel" name="bac_professionnel" value={formData.bac_professionnel} onChange={handleInputChange} placeholder="e.g., 4.5" required/>
               {shouldShowAverage(formData.bac_professionnel) && (
                 <>
                    <SubInfoLabel htmlFor="moyenne_formation_professionnel">Moyenne Admis Bac Pro *</SubInfoLabel>
                    <SubInput type="number" step="0.01" id="moyenne_formation_professionnel" name="moyenne_formation_professionnel" value={formData.moyenne_formation_professionnel} onChange={handleInputChange} placeholder="e.g., 12.85" required/>
                 </>
               )}
            </InfoItem>
          </InfoGrid>
           {/* Display Percentage Sum Warning */}
           {percentageSumWarning && (
              <PercentageSumWarning>{percentageSumWarning}</PercentageSumWarning>
            )}
        </InfoSection>

        {/* --- Specialty Scores (General Bac) Section --- */}
        {shouldShowAverage(formData.bac_general) && (
        <InfoSection>
              <SectionTitle>Scores par spécialité (bac général)</SectionTitle>
              <SectionSubtitle>Importance de la spécialité sur 5</SectionSubtitle>
            <InfoGrid gridTemplateColumns="repeat(auto-fit, minmax(250px, 1fr))"> 
                {generalSpecialtyLabels.map(label => (
                    <InfoItem key={label}>
                         <InfoLabel htmlFor={`score-gen-${label}`}>{label}</InfoLabel>
                         <StyledInput 
                            type="number" 
                              step="0.01"
                            id={`score-gen-${label}`}
                              name={`score-gen-${label}`} // Keep unique name for potential future use
                            value={scoreSpesGeneral[label]} 
                              onChange={(e) => handleScoreChange('general', label, e.target.value)} // Use generic handler
                              placeholder="1/5"
                         />
                    </InfoItem>
                ))}
            </InfoGrid>
        </InfoSection>
        )}

        {/* --- NEW Specialty Scores (Techno Bac) Section --- */}
        {shouldShowAverage(formData.bac_technologique) && (
          <InfoSection>
              <SectionTitle>Scores par série (bac technologique)</SectionTitle>
              <SectionSubtitle>Importance de la série sur 5</SectionSubtitle>
              <InfoGrid gridTemplateColumns="repeat(auto-fit, minmax(250px, 1fr))"> 
                  {technoSpecialtyLabels.map(label => (
                      <InfoItem key={`techno-${label}`}> {/* Added prefix to key */} 
                           <InfoLabel htmlFor={`score-techno-${label}`}>{label}</InfoLabel>
                           <StyledInput 
                              type="number" 
                              step="0.01"
                              id={`score-techno-${label}`}
                              name={`score-techno-${label}`} 
                              value={scoreSpesTechnologique[label]} 
                              onChange={(e) => handleScoreChange('technologique', label, e.target.value)} 
                              placeholder="1/5"
                           />
                      </InfoItem>
                  ))}
              </InfoGrid>
          </InfoSection>
        )}

        {/* --- NEW Specialty Scores (Pro Bac) Section --- */}
        {shouldShowAverage(formData.bac_professionnel) && (
          <InfoSection>
              <SectionTitle>Scores par option (bac professionnel)</SectionTitle>
              <SectionSubtitle>Importance de l'option sur 5</SectionSubtitle>
              <InfoGrid gridTemplateColumns="repeat(auto-fit, minmax(250px, 1fr))"> 
                  {proSpecialtyLabels.map(label => (
                      <InfoItem key={`pro-${label}`}> {/* Added prefix to key */} 
                           <InfoLabel htmlFor={`score-pro-${label}`}>{label}</InfoLabel>
                           <StyledInput 
                              type="number" 
                              step="0.01"
                              id={`score-pro-${label}`}
                              name={`score-pro-${label}`} 
                              value={scoreSpesProfessionnel[label]} 
                              onChange={(e) => handleScoreChange('professionnel', label, e.target.value)} 
                              placeholder="1/5"
                           />
                      </InfoItem>
                  ))}
              </InfoGrid>
          </InfoSection>
        )}

        {/* --- Links & Codes Section --- */}
        <InfoSection>
          <SectionTitle>Liens et codes</SectionTitle>
          <InfoGrid>
             <InfoItem>
              <InfoLabel htmlFor="link">Lien Formation (Parcoursup, etc.) *</InfoLabel>
              <StyledInput type="url" id="link" name="link" value={formData.link} onChange={handleInputChange} placeholder="https://..." required/>
            </InfoItem>
            <InfoItem>
              <InfoLabel htmlFor="site_web">Site Web Établissement *</InfoLabel>
              <StyledInput type="url" id="site_web" name="site_web" value={formData.site_web} onChange={handleInputChange} placeholder="https://..." required/>
            </InfoItem>
          </InfoGrid>
        </InfoSection>
        
        {error && <ErrorMessage>{error}</ErrorMessage>}
        {success && <SuccessMessage>{success}</SuccessMessage>}
        
        <ButtonContainer>
          <CancelButton onClick={onCancel} disabled={isSaving}>
            Annuler
          </CancelButton>
          <ConfirmButton onClick={handleSave} disabled={isSaving}>
            {isSaving ? 'Création...' : 'Créer la Formation'}
          </ConfirmButton>
        </ButtonContainer>
      </CreateCard>
    </CreateCardContainer>
  );
};

export default CreateCardComponent; 